import { z } from 'zod';

// CT-3015 step 2 (pensioner concession card). Captures the Pensioner Concession
// Card (PCC) details for an IDMatrix CENTRELINK check. `customerReferenceNumber`
// (CRN) is sensitive PII — never log it. `dateOfExpiry` (YYYY-MM-DD) must not be
// in the past: an already-expired card is rejected up front (month granularity).
export const verifyTitleSearchOwnerPensionerSchema = z.object({
  applicationId: z.string().min(1, 'applicationId is required'),
  titleSearchOwnerId: z.string().min(1, 'titleSearchOwnerId is required'),
  centrelink: z.object({
    nameOnCard: z.string().trim().min(1, 'nameOnCard is required'),
    // Australian CRN: 9 digits followed by a single check letter (e.g. 203456789A).
    customerReferenceNumber: z
      .string()
      .regex(/^\d{9}[A-Za-z]$/, 'customerReferenceNumber must be 9 digits followed by a letter'),
    dateOfExpiry: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'dateOfExpiry must be in YYYY-MM-DD format')
      .refine(value => {
        const [year, month] = value.split('-').map(Number);
        if (month < 1 || month > 12) return false;
        const now = new Date();
        // UTC deliberately (getUTCFullYear/getUTCMonth): the comparison is
        // month-granularity only, so a fixed UTC reference avoids an
        // off-by-one-month flip near midnight in AU timezones. A card is valid
        // through the end of its expiry month, so reject only when the expiry
        // month is strictly before the current month. Do NOT "fix" this to local time.
        const expiry = year * 12 + (month - 1);
        const current = now.getUTCFullYear() * 12 + now.getUTCMonth();
        return expiry >= current;
      }, 'Concession card has expired'),
    dateOfBirth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'dateOfBirth must be in YYYY-MM-DD format'),
  }),
});
